import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

/**
 * Reveal: slow, elegant scroll-driven entrance with optional stagger.
 * Use for editorial text reveals throughout the site.
 */
export const Reveal = ({
  children,
  delay = 0,
  duration = 1,
  y = 24,
  className = '',
  as = 'div',
  once = true,
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

/** Stagger container that animates children with their own delay attribute. */
export const RevealGroup = ({ children, className = '', stagger = 0.12 }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-80px' }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const RevealItem = ({ children, y = 20, className = '', as = 'div' }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      variants={{
        hidden: { opacity: 0, y },
        visible: { opacity: 1, y: 0, transition: { duration: 1, ease: EASE } },
      }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
